import { useCallback } from 'react'
import { usePushToTalkPermission } from './settings/usePushToTalkPermission'

export const useEnableVoiceMode = () => {
  const { setIsPushToTalkEnabled } = usePushToTalkPermission()

  return useCallback(async () => {
    setIsPushToTalkEnabled(true)
  }, [setIsPushToTalkEnabled])
}
